import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { getCsatReport } from '../services/api';
import { Th } from './NotionUI';

export const Stars = ({ value, size = 14 }) => (
  <span className="stars" style={{ fontSize: size }} aria-label={`${value}/5`}>
    {[1, 2, 3, 4, 5].map((n) => <span key={n} className={n <= value ? 'star-on' : 'star-off'}>★</span>)}
  </span>
);

/** Soddisfazione dei clienti: media, distribuzione e dettaglio per coda (valutazioni degli ultimi 90 giorni). */
function CsatPanel() {
  const { t } = useLanguage();
  const [data, setData] = useState(null);

  useEffect(() => {
    getCsatReport({ days: 90 }).then(setData).catch(() => setData(null));
  }, []);

  if (!data || data.count === 0) return null;
  const max = Math.max(1, ...Object.values(data.distribution));

  return (
    <section className="db-card sla-card">
      <header className="db-card-head"><h3>{t('dashboard.csatTitle')}</h3><span className="nt-muted">{t('dashboard.csatPeriod', { days: data.days })}</span></header>
      <div className="csat-top">
        <div className="csat-avg">
          <strong>{data.average.toFixed(1)}</strong>
          <Stars value={Math.round(data.average)} size={18} />
          <span className="nt-muted">{t('dashboard.csatCount', { count: data.count })}</span>
        </div>
        <div className="csat-dist">
          {[5, 4, 3, 2, 1].map((n) => (
            <div key={n} className="csat-dist-row">
              <span>{n} ★</span>
              <div className="csat-bar"><div className="csat-bar-fill" style={{ width: `${(data.distribution[n] / max) * 100}%` }} /></div>
              <span className="nt-muted">{data.distribution[n]}</span>
            </div>
          ))}
        </div>
      </div>
      {data.by_queue.length > 0 && (
        <div className="nt-table-wrap">
          <table className="nt-table cu-table">
            <thead>
              <tr>
                <Th icon="tag">{t('dashboard.slaQueue')}</Th>
                <Th icon="hash">{t('dashboard.csatRatings')}</Th>
                <Th icon="priority">{t('dashboard.csatAverage')}</Th>
              </tr>
            </thead>
            <tbody>
              {data.by_queue.map((q) => (
                <tr key={q.queue}>
                  <td><strong>{q.queue}</strong></td>
                  <td>{q.count}</td>
                  <td><Stars value={Math.round(q.average)} /> <span className="nt-muted">{q.average.toFixed(1)}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {data.low_ratings.length > 0 && (
        <>
          <h4 className="csat-low-title">{t('dashboard.csatLow')}</h4>
          <ul className="rp-list">
            {data.low_ratings.map((tk) => (
              <li key={tk.id} className="rp-li">
                <Link to={`/tickets/${tk.id}`} state={{ from: '/dashboard' }} className="rp-link">
                  <span className="rp-id">#{tk.id}</span>
                  <span className="rp-subject">{tk.subject}</span>
                </Link>
                <Stars value={tk.rating} />
                {tk.comment && <span className="nt-muted rp-extra">“{tk.comment}”</span>}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}

export default CsatPanel;
